import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import VoucherExpenseTable from './ExpenseTable'
import{Box} from '@chakra-ui/react';

const Expense = () => {
    return (
        <div>
            <HeaderSection
                title="View Expenses"
                breadcrumb={["Dashboard", "Voucher", "Expenses"]}
            />
                        <Box p={6}>

            <VoucherExpenseTable />
            </Box>
        </div>
    )
}

export default Expense